<pagination-controls
  previousLabel=""
  nextLabel=""
  (pageChange)="page($event)"
></pagination-controls>
